import React from "react";
import "./total-statistics.scss";
import { Card } from "antd";

const salesData = [
  { bank: "Bank A", sales: 5000 },
  { bank: "Bank B", sales: 3000 },
  { bank: "Bank C", sales: 2000 },
  { bank: "Bank D", sales: 1000 },
];
export const TotalStatistic = () => {
  return (
    <div className="total-statistic-container">
      <div className="total-item">
        <Card
          hoverable
          style={{
            background: "linear-gradient(to right, #6655FF, #FF55AA)",
          }}
        >
          <div className="total-content">
            <div className="total-title">Tổng doanh thu</div>
            <div className="total-number">1.806.030.231</div>
          </div>
        </Card>
      </div>
      <div className="total-item">
        <Card
          hoverable
          style={{
            background: "linear-gradient( to right, #6655FF, #55FFAA)",
          }}
        >
          <div className="total-content">
            <div className="total-title">Tổng lượt giao dịch</div>
            <div className="total-number">25.678</div>
          </div>
        </Card>
      </div>
    </div>
  );
};
